jQuery(function(){
	jQuery('.dropdown-btn').click(function(){
		var element = jQuery(this);
		jQuery('.dropdown-content').each(function(){
			if(jQuery(this) != element){
				if(jQuery(this).parent().hasClass('show')){
					jQuery(this).parent().removeClass('show');
					jQuery(this).parent().find('.dropdown-btn').attr('aria-expanded', false);
				}
			}
		});
		if(jQuery(this).hasClass('show')){
			jQuery(this).parent().removeClass('show');
			jQuery(this).attr('aria-expanded', false);
		}
		else{
			jQuery(this).parent().addClass('show');
			jQuery(this).attr('aria-expanded', true);
		}
	});
});

jQuery(document).on('click', function(event){
	var element = jQuery(event.target).parent();
	if(!jQuery(event.target).hasClass('dropdown-btn') && !element.hasClass('no-translation') && !element.parent().hasClass('no-translation')){
		jQuery('.dropdown-content').each(function(){
			jQuery(this).find('.no-translation').removeClass('open');
			if(jQuery(this).parent().hasClass('show')){
				jQuery(this).parent().removeClass('show');
				jQuery(this).parent().find('.dropdown-btn').attr('aria-expanded', false);
			}
		});
	}
});

document.addEventListener('DOMContentLoaded', function () {
    // Scroll to top button
    const backToTop = document.getElementById('back-to-top');
    if (backToTop) {
        const toggleVisibility = () => {
            const visible = window.scrollY > 300;
            backToTop.hidden = !visible;
            backToTop.classList.toggle('is-visible', visible);
        };

        window.addEventListener('scroll', toggleVisibility);
        toggleVisibility();

        backToTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // Floating feedback button
    const floatBtn = document.getElementById('feedback-float-btn');
    if (floatBtn) {
        floatBtn.addEventListener('click', function () {
            const feedbackBtn = document.getElementById('feedback-btn');
            const feedbackPanel = document.getElementById('footer-form-panel');
            if (!feedbackPanel) return;

            if (feedbackBtn && !feedbackPanel.classList.contains('open')) {
                feedbackBtn.click();
            }

            requestAnimationFrame(() => {
                setTimeout(() => {
                    const scrollTarget = feedbackBtn || feedbackPanel;
                    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });

                    const firstInput = feedbackPanel.querySelector('input, textarea');
                    if (firstInput) firstInput.focus({ preventScroll: true });
                }, 350);
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const panel = document.getElementById('footer-form-panel');
    if (!panel) return;
    // Panel starts collapsed: make its whole subtree (incl. the Gravity Form
    // fields, honeypot and submit button, even ones re-rendered via AJAX)
    // unreachable by keyboard and hidden from assistive tech.
    if (!panel.classList.contains('open')) {
        panel.setAttribute('inert', '');
    }
});

// Open feedback form
const feedbackBtn = document.getElementById('feedback-btn');
const feedbackPanel = document.getElementById('footer-form-panel');

if (feedbackBtn && feedbackPanel) {
    feedbackBtn.addEventListener('click', function () {
        const isOpen = !feedbackPanel.classList.contains('open');

        feedbackBtn.classList.toggle('open', isOpen);
        feedbackPanel.classList.toggle('open', isOpen);

        feedbackBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        feedbackBtn.textContent = isOpen ? footerFormTextClose : footerFormTextOpen;

        if (isOpen) {
            feedbackPanel.removeAttribute('inert');
        } else {
            feedbackPanel.setAttribute('inert', '');
        }
    });
}
